<template>
    <div>
        <p class="listLength">共计 <span>{{Total}}条</span></p>
        <LoadingFooter :finished="finished" v-model='loading' @load="onLoad" @scroll="$Bus.$emit('IsSee',false)">
            <div style="padding-top: 8vw;">
                <div class="items IsLoad" v-for="(item, index) in list" :key="index">
                    <div class="itemTopBox">
                        <div>
                            <span>验收单号</span>
                            <span>{{item.DH}}</span>
                        </div>
                        <div>
                            <span>供应商</span>
                            <span>{{item.GYSMC}}</span>
                        </div>
                        <div>
                            <span>使用科室</span>
                            <span>{{item.KSMC}}</span>
                        </div>
                        <div>
                            <span>设备名称</span>
                            <span>{{item.SBMC}}</span>
                        </div>
                        <div>
                            <span>规格型号</span>
                            <span>{{item.SBGG}}</span>
                        </div>
                        <div>
                            <span>单位</span>
                            <span>{{item.SBDW}}</span>
                        </div>
                        <div>
                            <span>设备单价</span>
                            <span>{{item.CGDJ}}</span>
                        </div>
                        <div>
                            <span>数量</span>
                            <span>{{item.SL}}</span>
                        </div>
                        <div>
                            <span>总金额</span>
                            <span>{{item.ZJE}}</span>
                        </div>
                        <div>
                            <span>品牌</span>
                            <span>{{item.PPMC}}</span>
                        </div>
                        <div>
                            <span>生产厂家</span>
                            <span>{{item.SCQYMC}}</span>
                        </div>
                        <div>
                            <span>注册证件号</span>
                            <span>{{item.ZCZJH}}</span>
                        </div>
                        <div>
                            <span>出厂日期</span>
                            <span>{{item.CCRQ}}</span>
                        </div>
                    </div>
                    <div class="itemBottomBox">
                        <div @click.stop="_delete(item, index)">删除</div>
                        <div @click.stop="goStorage(item)">入库</div>
                        <div @click.stop="pageLoad(item)">修改</div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div class="menu" key="0" v-show="IsSee">
                    <Field title="验收单号" placeholder="请输入" :text='search.DH'
                        @onMessage="value => search.DH = value" />
                    <Field title="供应商" placeholder="请输入供应商编号或名称" :text='search.GYSMC'
                        @onMessage="value => search.GYSMC = value" />
                    <Field title="设备名称" placeholder="请输入设备名称" :text='search.SBMC'
                        @onMessage="value => search.SBMC = value" />
                    <Field title="开始时间" placeholder="请选择" type="calendar" :text='search.StartDate'
                        @onMessage="value => search.StartDate = value" />
                    <Field title="结束时间" placeholder="请选择" type="calendar" :text='search.EndDate'
                        @onMessage="value => search.EndDate = value" />
                    <div class="search" @click="serach">查询</div>
                </div>
            </transition>
        </LoadingFooter>
    </div>
</template>

<script>
    import Field from '../field/field'
    import LoadingFooter from '../loadingFooter/loadingFooter'
    export default {
        name: 'WrkList',
        components: {
            Field,
            LoadingFooter
        },
        props: {
            IsSee: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                list: [],
                Total: 0,
                pageIndex: 1,
                search: {
                    DH: '',
                    GYSMC: '',
                    SBMC: '',
                    StartDate: '',
                    EndDate: '',
                },
                loading: true,
                finished: false,
                AcceptanceInfoList: {}
            }
        },
        mounted() {
            this.loading = true;
            this.finished = false;
            this.list = [];
            this.loadDataDefault();
        },
        methods: {
            loadDataDefault() {
                this.$post('api/CheckIncoming/PutInOrAuditList', {
                    PageIndex: this.pageIndex,
                    PageSize: 10,
                    DH: this.search.DH,
                    GYSMC: this.search.GYSMC,
                    SBMC: this.search.SBMC,
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    YSBZ: '1',
                    SHBZ: '0',
                    Store: this.$UserInfo.StoreCode,
                    Token: '123456789'
                }).then(result => {
                    this.Total = result.Total;
                    var that = this;
                    result.PutInOrAuditList.map((item) => {
                        that.list.push(item);
                    });
                    if ((this.pageIndex * 10) >= result.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                });
            },
            serach() {
                this.list = [];
                this.pageIndex = 1;
                this.loadDataDefault();
                this.$Bus.$emit('IsSee', false);
            },
            goStorage(item) { // 入库 → 跳转入库表单
                this.$router.push({
                    name: 'StorageEquipment',
                    params: { item }
                });
            },
            _delete(item, index) { // 删除入库单
                this.$Dialog.confirm({
                    message: '确定删除？'
                }).then(() => {
                    this.$get('api/CheckIncoming/DelPutInForm', {
                        DH: item.DH,
                        SBBH: item.SBMCBH,
                        HTBH: item.HTBH,
                        HTID: item.HTId
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast({
                                message: '删除成功!',
                                duration: 1500,
                                onClose: () => {
                                    this.Total -= 1;
                                    this.list.splice(index, 1);
                                }
                            });
                        } else this.$Toast(result.Msg);
                    });
                }).catch(() => {});
            },
            pageLoad(item) { // 修改 → 加载详情后跳转编辑页
                this.$get('api/CheckIncoming/LoadPutInInfo', {
                    Token: 'YTDF5EF3A6174564E5981A446158F106',
                    DH: item.DH,
                    SBBH: item.SBMCBH,
                }).then(result => {
                    this.AcceptanceInfoList = result.PutInInfoList[0];
                    this.AcceptanceInfoList.GLLB = '';
                    this.AcceptanceInfoList.LSBH = this.$UserInfo.UserId + this.$format(new Date(), 'YYYYMMDDHHmmss');
                    this.AcceptanceInfoList.ZJE = item.ZJE;
                    this.$router.push({
                        name: 'EquipmentAcceptanceDetails',
                        params: {
                            AcceptanceInfoList: this.AcceptanceInfoList,
                            AZYS: (result.PutInInfoList[0].AZYSQK || '').split(','),
                            IsAddOrUpdata: true,
                            PageState: false,
                        }
                    });
                });
            },
            onLoad() { // 触底加载
                if (!this.finished && !this.loading) {
                    this.loading = true;
                    this.pageIndex += 1;
                    this.loadDataDefault();
                }
            }
        },
        watch: {
            $route(to, from) {
                if (from.name === 'EquipmentAcceptanceDetails' || from.name === 'StorageEquipment') {
                    this.pageIndex = 1;
                    this.list = [];
                    this.loadDataDefault();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        margin-top: 12vw;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding: 36px 30px;

        .itemTopBox {
            border-bottom: 2px solid #eee;

            div {
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 32px;

                span:first-child {
                    flex: 1;
                    color: #858585;
                }

                span:last-child {
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 326px;
                    text-align: right;
                }
            }
        }

        .itemBottomBox {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            div {
                width: 180px;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;
                margin-right: 30px;

                &:first-child {
                    background: #dedede;
                    color: #858585;
                }

                &:nth-child(2) {
                    background: $THEME-COLOR;
                    color: #fff;
                }

                &:last-child {
                    background: $THEME-COLOR;
                    color: #fff;
                    margin-right: 0;
                }
            }
        }
    }

    .listLength {
        top: 25vw !important;
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: -580px;
        margin-left: 30px;
        transition: all .5s;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/PutInStorage/WrkList.vue